import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import { motion } from "framer-motion";
import { FolderOpen, Image, Home, Upload, Settings, Package } from "lucide-react";
import { useTheme } from "../contexts/ThemeContext";

const FooterNav: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isDark } = useTheme();

  const navItems = [
    { path: '/', icon: Home, label: 'Home' },
    { path: '/my-file', icon: FolderOpen, label: 'Mi archivo' },
    { path: '/generate', icon: Image, label: 'Generar con IA' },
    { path: '/catalog', icon: Package, label: 'Catálogo' },
    { path: '/publish', icon: Upload, label: 'Publicar con IA' },
    { path: '/settings', icon: Settings, label: 'Ajustes' },
  ];

  const isActive = (path: string) => {
    if (path === '/') {
      return location.pathname === '/';
    }
    return location.pathname.startsWith(path);
  };

  return (
    <motion.nav
      initial={{ y: 100, opacity: 0 }}
      animate={{ y: 0, opacity: 1 }}
      transition={{ duration: 0.5, delay: 0.4 }}
      className="fixed bottom-0 left-0 w-full bg-white dark:bg-gray-900 shadow-2xl border-t border-gray-200 dark:border-gray-700 z-40"
    >
      {/* Navigation content */}
      <div className="flex justify-around items-center py-4">
        {navItems.map((item, index) => {
          const Icon = item.icon;
          const active = isActive(item.path);
          
          return (
            <button
              key={item.path}
              onClick={() => navigate(item.path)}
              className="relative flex flex-col items-center"
            >
              <motion.div
                whileTap={{ scale: 0.9 }}
                className={`flex items-center justify-center p-2 transition-colors duration-200 ${
                  active 
                    ? "text-blue-500" 
                    : isDark 
                      ? "text-gray-400 hover:text-gray-300" 
                      : "text-gray-500 hover:text-gray-700"
                }`}
              >
                <Icon size={22} />
              </motion.div>
            </button>
          );
        })}
      </div>
    </motion.nav>
  );
};

export default FooterNav;